import { getDayInfo } from '../../utils/vietnamHolidays';
import { Storage } from '../../constants/storage';
import { isAuthenticated } from '../../utils/api';

const COMMON_GREETINGS = {
    general: [
        '{user}, mình giúp gì cho bạn?',
        'Chào {user}, bạn muốn phân tích mã nào?',
        '{user}, bạn cần mình hỗ trợ gì không?',
        'Bạn muốn mình xem cổ phiếu nào, {user}?',
        'Bạn cần định giá mã nào không, {user}?',
        'Bạn muốn phân tích kỹ thuật hay cơ bản?',
        '{user}, mình ở đây.',
        'Có gì cần giúp không, {user}?',
        'Hôm nay bạn muốn xem gì, {user}?',
        'Bạn có quan tâm mã nào không, {user}?',
    ],
};

const GREETING_SETS = {
    login: {
        morning_trading: [
            ...COMMON_GREETINGS.general,
            'Xin chào, {user}?',
            '{user}, muốn cập nhật thị trường sáng nay không?',
            'Cần mình điểm nhanh đầu phiên không, {user}?',
            'Bạn muốn định giá cổ phiếu nào, {user}?',
        ],
        afternoon_trading: [
            ...COMMON_GREETINGS.general,
            'Chiều rồi, Bạn có muốn xem gì không?',
            'Điểm nhanh thị trường chiều nay nhé, {user}?',
            '{user}, bạn muốn mình xem mã nào?',
            'Bạn cần đánh giá danh mục không, {user}?',
        ],
        evening_trading: [
            ...COMMON_GREETINGS.general,
            'Tối nay thế nào, {user}?',
            '{user}, xem lại thị trường hôm nay nhé?',
            'Bạn muốn định giá cổ phiếu nào, {user}?',
            'Bạn có muốn đánh giá BCTC doanh nghiệp nào không?',
        ],
        casual_trading: [
            ...COMMON_GREETINGS.general,
            '{user}, mình giúp gì cho bạn?',
            'Chào {user}, bạn muốn phân tích mã nào?',
            '{user}, bạn cần mình hỗ trợ gì không?',
            'Bạn muốn mình xem cổ phiếu nào, {user}?',
            'Bạn cần định giá mã nào không, {user}?',
            'Bạn muốn phân tích kỹ thuật hay cơ bản?',
            '{user}, mình ở đây.',
            'Có gì cần giúp không, {user}?',
            'Hôm nay bạn muốn xem gì, {user}?',
            'Bạn có quan tâm mã nào không, {user}?',
            'Muốn gợi ý cổ phiếu không, {user}?',
        ],

        morning_nontrading: [
            ...COMMON_GREETINGS.general,
            'Xin chào, {user}?',
            '{user}, muốn nghiên cứu cổ phiếu nào không?',
            'Sáng nay học về phân tích cơ bản nhé, {user}?',
            'Bạn muốn định giá cổ phiếu nào, {user}?',
            'Cổ phiếu nào đáng chú ý tuần này, {user}?',
        ],
        afternoon_nontrading: [
            ...COMMON_GREETINGS.general,
            'Chiều rồi, Bạn có muốn xem gì không?',
            'Cùng xem lại xu hướng dài hạn nhé, {user}?',
            '{user}, bạn muốn mình xem mã nào?',
            'Bạn cần đánh giá danh mục không, {user}?',
        ],
        evening_nontrading: [
            ...COMMON_GREETINGS.general,
            'Tối nay thế nào, {user}?',
            'Bạn muốn định giá cổ phiếu nào, {user}?',
            'Bạn có muốn đánh giá BCTC doanh nghiệp nào không?',
        ],
        casual_nontrading: [
            ...COMMON_GREETINGS.general,
            '{user}, mình giúp gì cho bạn?',
            'Chào {user}, bạn muốn phân tích mã nào?',
            '{user}, bạn cần mình hỗ trợ gì không?',
            'Bạn muốn mình xem cổ phiếu nào, {user}?',
            'Bạn cần định giá mã nào không, {user}?',
            'Bạn muốn phân tích kỹ thuật hay cơ bản?',
            '{user}, mình ở đây.',
            'Có gì cần giúp không, {user}?',
            'Hôm nay bạn muốn xem gì, {user}?',
            'Bạn có quan tâm mã nào không, {user}?',
            'Muốn tìm hiểu về doanh nghiệp nào, {user}?',
        ],

        comeback: [
            'Rất vui gặp lại {user}. Xem gì hôm nay?',
            'Bạn muốn phân tích cổ phiếu nào, {user}?',
        ],

        morning: [
            'Xin chào, {user}?',
            '{user}, muốn cập nhật thị trường sáng nay không?',
            'Cần mình điểm nhanh đầu phiên không, {user}?',
            'Bạn muốn định giá cổ phiếu nào, {user}?',
            'Cổ phiếu nào hút dòng tiền sáng nay?',
        ],
        afternoon: [
            'Chiều rồi, Bạn có muốn xem gì không?',
            'Điểm nhanh thị trường chiều nay nhé, {user}?',
            '{user}, bạn muốn mình xem mã nào?',
            'Bạn cần đánh giá danh mục không, {user}?',
            'Cổ phiếu nào đang bị định giá thấp?',
        ],
        evening: [
            'Tối nay thế nào, {user}?',
            '{user}, xem lại thị trường hôm nay nhé?',
            'Bạn muốn định giá cổ phiếu nào, {user}?',
            'Bạn có muốn đánh giá BCTC doanh nghiệp nào không?',
        ],
        casual: [
            '{user}, mình giúp gì cho bạn?',
            'Chào {user}, bạn muốn phân tích mã nào?',
            '{user}, bạn cần mình hỗ trợ gì không?',
            'Bạn muốn mình xem cổ phiếu nào, {user}?',
            'Bạn cần định giá mã nào không, {user}?',
            'Bạn muốn phân tích kỹ thuật hay cơ bản?',
            '{user}, mình ở đây.',
            'Có gì cần giúp không, {user}?',
            'Hôm nay bạn muốn xem gì, {user}?',
            'Bạn có quan tâm mã nào không, {user}?',
            'Muốn gợi ý cổ phiếu không, {user}?',
        ],
    },

    guest: {
        trading: [
            'Mình có thể giúp gì cho bạn?',
            'Bạn cần mình hỗ trợ điều gì?',
            'Bạn muốn hỏi mình điều gì?',
            'Mình giúp gì được cho bạn?',
            'Mình có thể giúp gì cho bạn?',
            'Bạn cần mình hỗ trợ điều gì?',
            'Bạn muốn tìm hiểu cổ phiếu nào?',
            'Cần mình xem định giá mã nào?',
            'Bạn muốn phân tích kỹ thuật hay cơ bản?',
            'Bạn cần tư vấn cổ phiếu hay danh mục?',
        ],
        nontrading: [
            'Mình có thể giúp gì cho bạn?',
            'Bạn muốn tìm hiểu cổ phiếu nào?',
            'Cần nghiên cứu doanh nghiệp nào không?',
            'Bạn muốn học về phân tích tài chính không?',
        ],
        general: [
            'Mình có thể giúp gì cho bạn?',
            'Bạn cần mình hỗ trợ điều gì?',
            'Bạn muốn hỏi mình điều gì?',
            'Mình giúp gì được cho bạn?',
        ],
        stock: [
            'Bạn muốn tìm hiểu cổ phiếu nào?',
            'Cần mình xem định giá mã nào?',
            'Bạn muốn phân tích kỹ thuật hay cơ bản?',
            'Bạn cần tư vấn cổ phiếu hay danh mục?',
        ],
    },
};

const FALLBACK_GREETING = 'Mình có thể giúp gì cho bạn?';
const LONG_ABSENCE_HOURS = 12;

const getRandomInterval = () => Math.floor(Math.random() * 4) + 1;

const isReturningAfterLongTime = () => {
    const lastVisit = localStorage.getItem(Storage.last_visit);
    if (!lastVisit) return false;
    const hoursSince = (Date.now() - parseInt(lastVisit, 10)) / 1000 / 60 / 60;
    return hoursSince > LONG_ABSENCE_HOURS;
};

const getCachedGreeting = () => {
    const cached = localStorage.getItem(Storage.greeting_cache);
    if (!cached) return null;
    try {
        const { greeting, timestamp, nextUpdateInMinutes } = JSON.parse(cached);
        const minutesPassed = (Date.now() - timestamp) / 1000 / 60;
        if (minutesPassed >= nextUpdateInMinutes) return null;
        return greeting;
    } catch {
        return null;
    }
};

const saveGreetingCache = (greeting) => {
    const cache = { greeting, timestamp: Date.now(), nextUpdateInMinutes: getRandomInterval() };
    localStorage.setItem(Storage.greeting_cache, JSON.stringify(cache));
};

const resolveLoginPool = () => {
    if (isReturningAfterLongTime()) return GREETING_SETS.login.comeback;
    const { timeOfDay, isNonTradingDay: isNonTrading } = getDayInfo();
    const poolKey = isNonTrading ? `${timeOfDay}_nontrading` : `${timeOfDay}_trading`;
    return (
        GREETING_SETS.login[poolKey] ||
        GREETING_SETS.login[timeOfDay] ||
        GREETING_SETS.login.casual
    );
};

const resolveGuestPool = () => {
    const { isNonTradingDay: isNonTrading } = getDayInfo();
    const key = isNonTrading ? 'nontrading' : 'trading';
    if (GREETING_SETS.guest[key]) return GREETING_SETS.guest[key];
    return [
        ...GREETING_SETS.guest.general,
        ...GREETING_SETS.guest.general,
        ...GREETING_SETS.guest.stock,
    ];
};

const pickFreshGreeting = (pool) => {
    const recent = JSON.parse(sessionStorage.getItem(Storage.recent_greetings) || '[]');
    let greeting;
    let attempts = 0;
    do {
        greeting = pool[Math.floor(Math.random() * pool.length)];
        attempts += 1;
    } while (recent.includes(greeting) && attempts < 10);
    const updated = [greeting, ...recent.slice(0, 2)];
    sessionStorage.setItem(Storage.recent_greetings, JSON.stringify(updated));
    return greeting;
};

export const getRandomGreeting = () => {
    try {
        const cached = getCachedGreeting();
        if (cached) {
            localStorage.setItem(Storage.last_visit, Date.now().toString());
            return cached;
        }

        const pool = isAuthenticated() ? resolveLoginPool() : resolveGuestPool();
        const greeting = pickFreshGreeting(pool);

        localStorage.setItem(Storage.has_visited, 'true');
        localStorage.setItem(Storage.last_visit, Date.now().toString());
        saveGreetingCache(greeting);

        return greeting || FALLBACK_GREETING;
    } catch {
        return FALLBACK_GREETING;
    }
};
